import { render, staticRenderFns } from "./CustomerApp.vue?vue&type=template&id=3b930684&scoped=true&"
import script from "./CustomerApp.vue?vue&type=script&lang=js&"
export * from "./CustomerApp.vue?vue&type=script&lang=js&"
import style0 from "./CustomerApp.vue?vue&type=style&index=0&id=3b930684&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b930684",
  null
  
)

export default component.exports